import styled from '@emotion/styled';
import { Link } from '~/shared/components/Link';
import { cover } from '~/shared/utils/styled';
import { breakpoints } from '~/theme';

export const StyledCategories = styled.div(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.space[1],

    [breakpoints.md]: {
        gridTemplateColumns: 'repeat(5, minmax(150px, 1fr))',
    },
}));

export const StyledCategory = styled.div(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    backgroundColor: theme.colors.offWhite,
    flexDirection: 'column',
    alignItems: 'center',

    [breakpoints.md]: {
        [`&:hover ${StyledAction}, &:active ${StyledAction}, &:focus ${StyledAction}`]: {
            svg: {
                transform: `translateX(${theme.space[2]})`,
            },
        },
    },
}));

export const StyledImageContainer = styled.div({
    position: 'relative',
    width: '100%',
    aspectRatio: '450/350',
    overflow: 'hidden',
});

export const StyledAction = styled.div(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    fontSize: theme.fontSizes.beetle,
    padding: `${theme.space[4]} ${theme.space[1]}`,
    gap: theme.space[2],
    svg: {
        height: '25px',
        width: '25px',
        transition: `transform 250ms ${theme.easings.smoothEase}`,
    },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
    fontSize: theme.fontSizes.beetle,
    ...cover,
}));
